module.exports = __webpack_public_path__ + "static/media/bring-forward.f5382033.svg";